import ThemeExtractor from "../../../core/components/ThemeExtractor";
import RichTextRenderer from "../../../forms/components/RichText/RichTextRenderer";
import { RichTextType } from "../../../resources/modelTypes";
import { css } from "@emotion/react";
import React, { memo } from "react";

export type ThemedRichTextProps = {
  content: RichTextType | null;
};

const ThemedRichText = ({ content }: ThemedRichTextProps) => (
  <ThemeExtractor rules={["linkColor"]}>
    {({ linkColor }) => (
      <div
        css={css`
          a {
            color: ${linkColor};
          }
        `}
      >
        <RichTextRenderer value={content} />
      </div>
    )}
  </ThemeExtractor>
);

const MemoizedThemedRichText = memo(ThemedRichText);

export { MemoizedThemedRichText as ThemedRichText };
